<a [routerLink]="item.path"
   [routerLinkActive]="['active']"
   [routerLinkActiveOptions]="{exact: true}"
   role="link"
   class="nav-link "
   ngClass="{{ additionalClasses }}">
  {{ item.displayText }}
</a>
